import { IAuthRealm } from '../utils';
import { IWorkPhase } from './workflow-phase-ownership';

export const permissionLevel = [
  'viewer',
  'task_completer',
  'decision_maker'
] as const;
export type IPermissionLevel = (typeof permissionLevel)[number];
export type IRoleName = string;
export type IPermission = Partial<Record<IWorkPhase, IPermissionLevel>>;
export type IRoleConfig = Record<IRoleName, IPermission>;
export type IRoleDisplayNames = Record<IRoleName, string>;

export const IOrganizationType = ['publisher', 'society'] as const;
export type IOrganizationType = (typeof IOrganizationType)[number];

export type IArticleType = {
  id: string;
  name: string;
  description: string;
  isBaseArticle?: boolean;
};
export type ITags = {
  id: string;
  name: string;
  usage: string;
  description: string;
  usageCount: number;
  submissionContextId?: string;
  journal?: {
    id: string;
    name: string;
    shortname: string;
  };
  tagColor: string;
  tagCategory: string;
  tagDescription: string;
  tagCategoryId?: string;
};
export type IPublonsConfig = {
  enabled: boolean;
  publonsEndpoint: string;
  publonsAPISecretName: string;
};
export type ISTMConfig = {
  enabled: boolean;
  stmSubmitEndpoint: string;
  stmRemoveEndpoint: string;
};
export type ICSIConfig = {
  enabled: boolean;
  csiwebClientID: string;
  csiWatchdogSearchPartnerID: string;
};
export type IOrganization = {
  shortname: string;
  name: string;
  type: IOrganizationType;
  id: string;
  description: string;
  media?: {
    logo: string;
  };
  roleConfigs?: IRoleConfig;
  roleDisplayNames?: IRoleDisplayNames;
  articleTypes: IArticleType[];
  idpConfig: IDPConfig;
  publonsConfig?: IPublonsConfig;
  stmConfig?: ISTMConfig;
  csiConfig?: ICSIConfig;
  websiteUrl?: string;
};

/**
 * type IDPConfig:
 * - authRealm: part of the URL. 'm' = default (Morressier). otherwise, organization shortname (e.g. 'iopp')
 * - exclusive: if the organization exclusively uses one IDP. Used to forward directly to the IDP login screen, bypassing KeyCloak Login page.
 * - idpName: if exclusive = true, which IDP is exclusively used by the Org. idpName = IDP config in KeyCloak. e.g. 'ioppublishing'
 */
export type IDPConfig =
  | { authRealm: IAuthRealm; exclusive: true; idpName: string }
  | { authRealm: IAuthRealm; exclusive: false };
